<template>
  <v-card class="mb-3">
    <v-card-title class="customer-card-header">
      {{ customerReport.name }} -&nbsp;
      <span class="font-weight-normal">
        {{ formatHeaderDate(startDate) }} {{ $t('to') }} {{ formatHeaderDate(endDate) }}
      </span>
    </v-card-title>
    <v-card-text>
      <c3-chart :height="325" :data="chartData" :config="chartConfig" type='area' />
    </v-card-text>
  </v-card>
</template>

<script>
import Moment from 'moment-timezone'
import { map, round } from 'lodash'
import C3Chart from '@/components/shared/chart/C3Chart'

export default {
  name: 'FleetHealthHistoryReportCard',
  components: {
    C3Chart
  },
  props: {
    customerReport: {
      type: Object
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    }
  },
  computed: {
    chartData () {
      const dateColumn = map(this.customerReport.data, x => x.date)
      dateColumn.unshift('date')
      const healthColumn = map(this.customerReport.data, x => {
        const total = x.num_healthy + x.num_unhealthy
        if (total > 0) {
          return round(x.num_healthy / total * 100)
        }
        return null
      })
      healthColumn.unshift(this.$t('percentage_of_healthy_vehicles'))
      return {
        x: 'date',
        columns: [
          dateColumn,
          healthColumn
        ]
      }
    },
    /**
     * The chart config.
     */
    chartConfig () {
      return {
        axis: {
          x: {
            label: {
              text: this.$t('date')
            },
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d',
              centered: true,
              culling: true
            }
          },
          y: {
            label: {
              text: this.$t('percentage_of_healthy_vehicles')
            },
            tick: {
              values: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
              format: function (d) {
                return round(d, 1) + '%'
              },
              culling: true
            },
            max: 100
          }
        },
        line: {
          connectNull: true
        }
      }
    }
  },
  methods: {
    formatHeaderDate (date) {
      // parseZone keeps the offset the report was generated with, so the header always matches the range that was
      // selected in the form (and queried on the back end) rather than shifting with the viewer's browser timezone.
      return Moment.parseZone(date).format('ll')
    }
  }
}
</script>

<style scoped>
.customer-card-header {
  font-weight: bold;
  font-size: 1.1rem;
}
</style>
